import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, Volume2, VolumeX, Play } from "lucide-react";

export const PROMO_SRC = "/promo/threadlist_spot.mp4";
export const PROMO_WEBM = "/promo/threadlist_spot.webm";
export const PROMO_POSTER = "/promo/poster.jpg";

/** The ThreadList TV spot. Autoplays muted (browser rule), tap for sound, one-click MP4 download. */
export const PromoVideo = ({ className = "", onUnavailable }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [paused, setPaused] = useState(false);
  const toggleSound = () => {
    const v = ref.current; if (!v) return;
    v.muted = !v.muted; setMuted(v.muted);
    if (v.paused) v.play().catch(() => {});
  };
  const togglePlay = () => { const v = ref.current; if (!v) return; if (v.paused) { v.play().catch(() => {}); } else { v.pause(); } };
  return (
    <div className={`group relative rounded-3xl overflow-hidden bg-foreground shadow-lift aspect-video ${className}`} data-testid="promo-video">
      <video
        ref={ref}
        poster={PROMO_POSTER}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        onPlay={() => setPaused(false)}
        onPause={() => setPaused(true)}
        onClick={togglePlay}
        className="h-full w-full object-cover cursor-pointer"
        aria-label="ThreadList commercial"
        data-testid="promo-video-el"
      >
        <source src={PROMO_SRC} type="video/mp4" />
        {/* VP9 fallback: browsers without H.264 (and headless test browsers) */}
        <source src={PROMO_WEBM} type="video/webm" onError={() => onUnavailable?.()} />
      </video>
      {paused && (
        <button type="button" onClick={togglePlay} className="absolute inset-0 grid place-items-center" aria-label="Play" data-testid="promo-video-play">
          <span className="h-16 w-16 rounded-full bg-background/90 backdrop-blur grid place-items-center shadow-lift"><Play className="h-6 w-6 ml-0.5" /></span>
        </button>
      )}
      <div className="absolute left-3 right-3 bottom-3 flex items-center justify-between gap-2">
        <Button type="button" size="sm" onClick={toggleSound} className="rounded-full h-9 px-3.5 bg-background/90 text-foreground hover:bg-background backdrop-blur border border-border/60" data-testid="promo-video-sound">
          {muted ? <><VolumeX className="h-4 w-4 mr-1.5" /> Sound on</> : <><Volume2 className="h-4 w-4 mr-1.5" /> Mute</>}
        </Button>
        <Button asChild size="sm" variant="secondary" className="rounded-full h-9 px-3.5 bg-background/90 hover:bg-background backdrop-blur border border-border/60">
          <a href={PROMO_SRC} download="ThreadList-spot.mp4" data-testid="promo-video-download"><Download className="h-4 w-4 mr-1.5" /> MP4</a>
        </Button>
      </div>
      <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-background/90 backdrop-blur px-2.5 h-7 text-[11px] font-semibold border border-border/60"><span className="h-1.5 w-1.5 rounded-full bg-good animate-pulse" /> The spot · 0:46</span>
    </div>
  );
};
